export default __webpack_public_path__ + "static/media/play.3d107d35.svg";